export default __webpack_public_path__ + "static/leena press release-458bbb1657aba871c98c400200867a56.png";